// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"292":"d6dc6743","334":"1b9e81bc","441":"b3ca950b","721":"c3ccb135"}[chunkId] + ".chunk.css";
};